var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Tabs, Tab, LinearProgress, Box, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import PageLayout from '../../atoms/PageLayout';
import { useOffice } from '../../../hooks/useOffice';
import RoasterAdvanceReceivedTable from './RoasterAdvanceReceivedTable';
import ColumnValueSelect from '../../MaterialTable/ColumnValueSelect';
var AdminOfficeBalanceSheetEntryPage = function () {
    var officeListItems = useOffice().officeListItems;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = React.useState(new Date()), selectDate = _b[0], setSelectDate = _b[1];
    var _c = React.useState(''), selectOfficeId = _c[0], setSelectOfficeId = _c[1];
    React.useEffect(function () {
        if (officeListItems.length === 0)
            return;
        setSelectOfficeId(officeListItems[0].value);
    }, [officeListItems]);
    if (!selectOfficeId)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { backLink: true, title: t('pages.balanceSheetEntry.title') },
        React.createElement(Box, { mt: 1 },
            React.createElement(ColumnValueSelect, { value: selectOfficeId, items: officeListItems, onChange: function (id) { return setSelectOfficeId(id); } })),
        React.createElement(Box, { mt: 1 },
            React.createElement(DatePicker, { open: open, onClose: function () { return setOpen(false); }, views: ['year', 'month'], minDate: new Date('2020-01-01'), maxDate: new Date(), value: selectDate, inputFormat: "yyyy-MM", onChange: function (newDate) { return setSelectDate(newDate || new Date()); }, renderInput: function (params) {
                    var inputProps = params.inputProps, otherProps = __rest(params, ["inputProps"]);
                    return (React.createElement(TextField, __assign({}, otherProps, { helperText: null, onClick: function () { return setOpen(true); }, inputProps: __assign(__assign({}, inputProps), { readOnly: true }) })));
                } })),
        React.createElement(Tabs, { value: 'advance_received' },
            React.createElement(Tab, { value: "advance_received", label: t('pages.balanceSheetEntry.advanceReceived'), onClick: function () {
                    return navigate("/admin/office_balance_sheet_entries/advance_received");
                } })),
        React.createElement(RoasterAdvanceReceivedTable, { year: selectDate.getFullYear(), month: selectDate.getMonth() + 1, officeId: selectOfficeId })));
};
export default AdminOfficeBalanceSheetEntryPage;
